import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterModule, Routes } from '@angular/router';
import { AuthCallbackComponent } from 'auth-callback-lib';
import { AssistManagerLandingComponent } from './components/assist-manager-landing/assist-manager-landing.component';
import { BhCardComponent } from './components/bh-card/bh-card.component';
import { NotetakerCardComponent } from './components/notetaker-card/notetaker-card.component';
import {
  NotetakerResultComponent
} from './components/notetaker-card/notetaker-result/notetaker-result.component';
import {
  NotetakerManagerComponent
} from './components/notetaker-manager/notetaker-manager.component';
import {
  QuestionManagerComponent
} from './components/notetaker-manager/question-manager/question-manager.component';

export const assistManagerUrl = 'manager';

const bhCardGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  if (route.queryParamMap.has('CorporationID')) {
    return true;
  }
  return inject(Router).createUrlTree([assistManagerUrl]);
};

export const routes: Routes = [
  { path: '', component: BhCardComponent, canActivate: [bhCardGuard] },
  { path: assistManagerUrl, component: AssistManagerLandingComponent },
  { path: 'notetaker', component: NotetakerCardComponent},
  { path: 'notetaker-result', component: NotetakerResultComponent },
  { path: 'notetaker-manager', component: NotetakerManagerComponent },
  { path: 'notetaker-manager-questions', component: QuestionManagerComponent },
  { path: 'callback', component: AuthCallbackComponent },
  { path: '**', component: AssistManagerLandingComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
